export default "__VITE_ASSET__CRfoDL97__"